export default __webpack_public_path__ + "static/media/negative-2.73d1ebfb.png";